import { useQuery } from '@tanstack/react-query';
import { getProcessedTimesheetHistory } from '../Services/ProcessedTimesheetService';

const useGetProcessedTimesheetHistory = (params, options = {}) =>
    useQuery({
        queryKey: ['getProcessedTimesheetHistory', params],
        queryFn: () => getProcessedTimesheetHistory(params.processedTimesheetId),
        enabled: !!params?.processedTimesheetId,
        ...options,
    });

export default useGetProcessedTimesheetHistory;
